import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import KeywordsFilter from "./AllFilterComponent/KeywordsFilter";
import SpecialitiesFilter from "./AllFilterComponent/SpecialitiesFilter";
import PriceFilter from "./AllFilterComponent/PriceFilter";
import ClearAllorOnebyOne from "./ClearAllorOnebyOne";
import { useAllFilterBaseContext } from "../../../../Context/AllFilterBaseContext";
import AuctionType from "./AllFilterComponent/AuctionType";
import LanguageType from "./AllFilterComponent/LanguageType";
import SortType from "./AllFilterComponent/SortType";
import DeliveryType from "./AllFilterComponent/DeliveryType";
import CountryOption from "./AllFilterComponent/CountryOption";
import IndustryOption from "./AllFilterComponent/IndustryOption";
import EducationType from "./AllFilterComponent/EducationType";
import LocationType from "./AllFilterComponent/LocationType";
import ExperienceType from "./AllFilterComponent/ExperienceType";
import LocationCheckbox from "./AllFilterComponent/LocationCheckbox";
import ExpertTypeCheckbox from "./AllFilterComponent/ExpertTypeCheckbox";
import HiringTypeCheckbox from "./AllFilterComponent/HiringTypeCheckbox";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import StatusType from "./AllFilterComponent/StatusType";
import SubcategoryOption from "./AllFilterComponent/SubcategoryOption";
import SortOptionType from "./AllFilterComponent/SortOptionType";
import SubcategoryWithoutfilter from "./AllFilterComponent/SubcategoryWithoutfilter";

const FilterAll = () => {
  const {
    state,
    setSortByTime,
    setSortLanguage,
    setSortPostType,
    locationTypeChange,
    setSearch,
    setCities,
    setSortAuction,
    setDeliverytype,
    setEducation,
    setLocation,
    setExperience,
    expertTypeChange,
    hiringTypeChange,
    setStatusType,
    clearAllFilterFields,
  } = useAllFilterBaseContext();

  const {
    sortByTime,
    statustype,
    sortlanguage,
    sortposttype,
    locationType,
    expertType,
    hiringType,
    deliverytype,
    sortAuction,
    education,
    location,
    cities,
    experience,
  } = state;
  const filterdata = useSelector(({ filter: { filterdata } }) => filterdata);
  const [filter, setfilter] = useState(false);

  const isSelected = (id) => {
    return sortposttype?.some((post) => post.id == id);
  };

  const isSelected2 = (id) => {
    return locationType?.some((post) => post.id == id);
  };

  useEffect(() => {
    return () => {
      clearAllFilterFields();
    };
  }, []);

  const renderFilter = (filter) => {
    switch (filter.filter_type) {
      case "2":
        return (
          <div className="filter-cont" key={filter.id}>
            {filter.filter_type &&
              (filter.id == 5 ||
                filter.id == 19 ||
                filter.id == 24 ||
                filter.id == 28 ||
                filter.id == 33 ||
                filter.id == 37 ||
                filter.id == 46) && (
                <>
                  <SortType
                    setSortByTime={setSortByTime}
                    sortByTime={sortByTime}
                    filter={filter}
                  />
                </>
              )}
            {filter.filter_type && filter.id == 27 && (
              <>
                <div className="filter-cont" key={filter.id}>
                  <SortOptionType
                    filter={filter}
                  />
                </div>
              </>
            )}
            {filter.filter_type && filter.id == 34 && (
              <>
                <div className="filter-cont" key={filter.id}>
                  <StatusType
                    filter={filter}
                    statusType={statustype}
                    setStatusType={setStatusType}
                  />
                </div>
              </>
            )}
            {filter.filter_type && filter.id == 23 && (
              <>
                <div className="filter-cont" key={filter.id}>
                  <label>{filter.title}</label>
                  <CountryOption values={filter.values} title={filter.title} />
                </div>
              </>
            )}
            {filter.filter_type && (filter.id == 10 || filter.id == 40) && (
              <>
                <LanguageType
                  setSortLanguage={setSortLanguage}
                  filter={filter}
                  sortlanguage={sortlanguage}
                />
              </>
            )}
            {filter.filter_type && filter.id == 31 && (
              <>
                <AuctionType
                  setSortAuction={setSortAuction}
                  filter={filter}
                  sortAuction={sortAuction}
                />
              </>
            )}
            {filter.filter_type && filter.id == 41 && (
              <>
                <EducationType
                  setEducation={setEducation}
                  filter={filter}
                  education={education}
                />
              </>
            )}
            {filter.filter_type && filter.id == 42 && (
              <>
                <LocationType
                  setLocation={setLocation}
                  filter={filter}
                  location={location}
                />
              </>
            )}
            {filter.filter_type && (filter.id == 15 || filter.id == 43) && (
              <>
                <ExperienceType
                  setExperience={setExperience}
                  filter={filter}
                  experience={experience}
                />
              </>
            )}
          </div>
        );
      case "3":
        return (
          <div className="filter-cont" key={filter.id}>
            {filter.filter_type && filter.id == 14 && (
              <>
                <LocationCheckbox
                  locationType={locationType}
                  filter={filter}
                  locationTypeChange={locationTypeChange}
                />
              </>
            )}
            {filter.filter_type && filter.id == 16 && (
              <>
                <ExpertTypeCheckbox
                  expertType={expertType}
                  filter={filter}
                  expertTypeChange={expertTypeChange}
                />
              </>
            )}
            {filter.filter_type && filter.id == 18 && (
              <>
                <HiringTypeCheckbox
                  hiringType={hiringType}
                  filter={filter}
                  hiringTypeChange={hiringTypeChange}
                />
              </>
            )}
          </div>
        );
      case "4":
        return (
          <div className="filter-cont" key={filter.id}>
            {filter.filter_type && filter.id == 6 && (
              <>
                <h6>{filter?.title}</h6>
                {filter.values.map((value) => (
                  <div className="input-check" key={value.id}>
                    <input
                      type="radio"
                      className="form-control"
                      checked={isSelected(value.id)}
                      onChange={() => setSortPostType(value)}
                    />
                    <span>{value.title}</span>
                  </div>
                ))}
              </>
            )}
          </div>
        );
      case "5":
        return (
          <div className="filter-cont" key={filter.id}>
            {filter.filter_type &&
              (filter.id == 8 ||
                filter.id == 49 ||
                filter.id == 50 ||
                filter.id == 51) && (
                <>
                  <div className="filter-cont" key={filter.id}>
                    <h6>{filter?.title}</h6>
                    <KeywordsFilter values={filter.values} filter={filter} />
                  </div>
                </>
              )}
            {filter.filter_type && (filter.id == 53 || filter.id == 54) && (
              <>
                <div className="filter-cont" key={filter.id}>
                  <h6>{filter?.title}</h6>
                  <SubcategoryOption values={filter.values} filter={filter} />
                </div>
              </>
            )}
            {filter.filter_type && (filter.id == 55) && (
              <>
                <div className="filter-cont" key={filter.id}>
                  <h6>{filter?.title}</h6>
                  <SubcategoryWithoutfilter values={filter.values} />
                </div>
              </>
            )}
            {filter.filter_type &&
              (filter.id == "20" ||
                filter.id == 20 ||
                filter.id == 25 ||
                filter.id == 29 ||
                filter.id == 44 ||
                filter.id == 38) && (
                <div className="filter-cont" key={filter.id}>
                  <h6>{filter?.title}</h6>
                  <IndustryOption values={filter.values} filter={filter} />
                </div>
              )}
            {filter.filter_type &&
              (filter.id == 9 ||
                filter.id == 13 ||
                filter.id == 21 ||
                filter.id == 39) && (
                <>
                  <div className="filter-cont" key={filter.id}>
                    <h6>{filter?.title}</h6>
                    <SpecialitiesFilter values={filter.values}  placeholder={filter.title} />
                  </div>
                </>
              )}
            {filter.filter_type && filter.id == 45 && (
              <>
                <div className="filter-cont" key={filter.id}>
                  <h6>{filter?.title}</h6>
                  <CountryOption values={filter.values} />
                </div>
              </>
            )}
          </div>
        );
      case "6":
        return (
          <div className="filter-cont" key={filter.id}>
            {filter.filter_type &&
              (filter.id == 12 ||
                filter.id == 23 ||
                filter.id == 27 ||
                filter.id == 34 ||
                filter.id == 36 ||
                filter.id == 47) && (
                <>
                  <div className="filter-cont" key={filter.id}>
                    <h6>{filter?.title}</h6>
                    <input
                      value={state?.cities}
                      onChange={(e) => setCities(e.target.value)}
                      placeholder={"Search here"}
                    />
                  </div>
                </>
              )}
            {/* {filter.filter_type && filter.id == 21 && (
              <div className="filter-cont" key={filter.id}>
                <h6>{filter?.title}</h6>
                <input
                  value={state?.search}
                  onChange={(e) => setSearch(e.target.value)}
                  placeholder={"Search here"}
                />
              </div>
            )} */}
          </div>
        );
      case "7":
        return <PriceFilter filter={filter} setfilter={setfilter} />;
      case "8":
        return (
          <div className="filter-cont" key={filter.id}>
            {filter.filter_type &&
              (filter.id == 5 ||
                filter.id == 19 ||
                filter.id == 24 ||
                filter.id == 28 ||
                filter.id == 33 ||
                filter.id == 37 ||
                filter.id == 46) && (
                <>
                  <SortType
                    setSortByTime={setSortByTime}
                    sortByTime={sortByTime}
                    filter={filter}
                  />
                </>
              )}
            {filter.filter_type && (filter.id == 10 || filter.id == 40) && (
              <>
                <LanguageType
                  setSortLanguage={setSortLanguage}
                  filter={filter}
                  sortlanguage={sortlanguage}
                />
              </>
            )}
            {filter.filter_type && filter.id == 31 && (
              <>
                <AuctionType
                  setSortAuction={setSortAuction}
                  filter={filter}
                  sortAuction={sortAuction}
                />
              </>
            )}
            {filter.filter_type && filter.id == 41 && (
              <>
                <EducationType
                  setEducation={setEducation}
                  filter={filter}
                  education={education}
                />
              </>
            )}
            {filter.filter_type && filter.id == 42 && (
              <>
                <LocationType
                  setLocation={setLocation}
                  filter={filter}
                  location={location}
                />
              </>
            )}
            {filter.filter_type && (filter.id == 15 || filter.id == 43) && (
              <>
                <ExperienceType
                  setExperience={setExperience}
                  filter={filter}
                  experience={experience}
                />
              </>
            )}
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div>
      <button className={filter ? "filter-btn active" : "filter-btn"} onClick={() => setfilter(!filter)} style={{ zIndex: '999', position: 'relative' }}>
        <img
          src={`${CloudStorage.cloudurl}/Assets/Images/common/filter.svg`}
          alt=""
        />{" "}
        Filter
      </button>
      <div className={filter ? "filter-sec active" : "filter-sec"}>
        <div className="close-icon">
          <button onClick={() => setfilter(false)}>
            <i className="fa-solid fa-xmark"></i>
          </button>
        </div>
        <ClearAllorOnebyOne setfilter={setfilter} />
        {filterdata.map((filter) => renderFilter(filter))}
      </div>
    </div>
  );
};

export default FilterAll;
